







import { computed, defineComponent } from '@vue/composition-api'
import CustomerPasswordRequireChange from '@/components/domains/customers/customer/CustomerPasswordRequireChange.vue'
import UserPassword from '@/components/domains/auth/users/UserPassword.vue'
import type { Customer } from '@futureecom/futureecom-js/dist/services/customer-service'
import type { PropType } from '@vue/composition-api'
import type { ValidationErrors } from '@/types/validator'

export default defineComponent({
  name: 'CustomerSecurity',

  components: { UserPassword, CustomerPasswordRequireChange },

  props: {
    value: {
      type: Object as PropType<Customer>,
      required: true
    },
    errors: {
      type: Object as PropType<ValidationErrors>,
      default: () => ({})
    }
  },

  setup(props, { emit }) {
    const customer = computed({
      get: () => props.value,
      set: (val) => emit('input', val)
    })

    return {
      customer
    }
  }
})
